import { css } from '@emotion/react';

export const tableContainerStyle = css`
  width: 100%;
  overflow-x: auto;

  &::-webkit-scrollbar {
    background: transparent;
    width: 6px;
    max-width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--theme-COLORS-BLACK-600);
    border-radius: 3px;
    width: 6px;
    height: 6px;
  }
`;

const baseWidth = 1920;
const widthDifference = 900;

export const tableStyle = (fixHeight?: boolean) => css`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  min-height: ${fixHeight ? '200px' : 'unset'};
  table-layout: fixed;

  td,
  th {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media (max-width: 900px) {
    width: ${baseWidth - widthDifference}px;
  }
`;

export const headerStyle = css`
  background-color: #f4f4f4;
  color: #333;
`;

export const rowStyle = (expanded: boolean, isBlur?: boolean) => css`
  background-color: ${expanded ? '#242424' : '#151515'};
  filter: ${isBlur ? 'blur(5px)' : 'none'};
`;

export const cellStyle = (canExpanded: boolean) => css`
  padding: 8px;
  border-top: 1px solid #2e2e2e !important;
  border-bottom: 1px solid #2e2e2e !important;
  color: #fff;
  cursor: ${canExpanded ? 'pointer' : 'unset'};
  background-color: transparent;
`;

export const sortIconStyle = (isSorted: boolean) => css`
  transform: ${isSorted ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: transform 0.3s ease;
`;

export const openStyle = css`
  background-color: #242424;
`;

export const stickyColumnStyle = css`
  position: sticky;
  left: 0;
  z-index: 1;
  background-color: #151515;
  width: 420px;

  @media (max-width: 1200px) {
    width: 200px;
  }

  &::before {
    content: '';
    position: absolute;
    right: 10px;
    top: 8px;
    bottom: 8px;
    width: 1px;
    background-color: #2e2e2e;
  }
`;
